export default "/images/Banner_simulador.png?b721777735a439633dacabdbd265f9d5";